import React, {
  useState,
  useRef
} from 'react';
import moment from 'moment';
import DateRangePicker from 'react-daterange-picker';

import PropTypes from 'prop-types';
import useOnEventOutside from '../../hooks/useOnEventOutside';
import CaretLeftIcon from '../../icons/caret_left.svg';
import CalendarIcon from '../../icons/calendar.svg';
import DropdownIcon from '../../icons/dropdown.svg';
import styles from './index.module.scss';

moment.updateLocale('en', {
  calendar: {
    sameDay: '[Today], MM/DD/YY',
    nextDay: '[Tomorrow], MM/DD/YY',
    nextWeek: 'MM/DD/YY',
    sameElse: 'MM/DD/YY'
  }
});

const Datepicker = ({
  label,
  defaultDate,
  onChange
}) => {
  const wrapperRef = useRef(null);
  const [current, setCurrent] = useState(defaultDate || moment());
  const [open, setOpen] = useState(false);

  useOnEventOutside(wrapperRef, () => setOpen(false), ['mousedown']);

  const update = (value) => {
    setCurrent(value);
    onChange(value);
    setOpen(false);
  };

  return (
    <div className={styles.datepicker} ref={wrapperRef}>
      <div className={styles.element} onClick={() => setOpen(!open)}>
        <CalendarIcon />
        <span className={styles.label}>{label}</span>
        <span className={styles.value}>{current.calendar()}</span>
        <DropdownIcon className={styles.arrows} />
      </div>
      <div className={`${styles.calendar} ${open ? styles.open : ''}`}>
        <DateRangePicker
          paginationArrowComponent={(a) => (<div className={styles.next} onClick={() => a.onTrigger()}>{}<CaretLeftIcon /></div>)}
          onSelectStart={update}
          numberOfCalendars={1}
          firstOfWeek={1}
          minimumNights={0}
          minimumDate={moment().toDate()}
          singleDateRange
        />
      </div>
    </div>
  );
};

Datepicker.propTypes = {
  onChange: PropTypes.func,
  defaultDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  label: PropTypes.string,
};

export default Datepicker;
